export const formatNumber = (number) => {
	return new Intl.NumberFormat('fr-FR', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})
		.format(number)
		.replace(',', '.')
}
